import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import ActivityLogData from "../../data/ActivityLogData";

const ActivityLogMenu = () => {
  return (
    <div>
      <DashboardTitleComponent text={"Log Aktivitas"} />
      <ActivityLogData />
    </div>
  );
};

export default ActivityLogMenu;
